export const GROUPS_SELECTOR = 'fetch/GROUPS_SELECTOR';
export const REFRESH_GROUPS_LIST = 'fetch/REFRESH_GROUPS_LIST';
export const LIST_GROUPS_ATOM = 'fetch/LIST_GROUPS_ATOM';
